module.exports = __webpack_public_path__ + "static/media/car.bd427ccc.jpg";